import { comMapping } from '@/components/util/Function/comMapping';

export function getdata() {
    var obj = {
        searchlist: [
            {
                prop: 'sobName',
                label: '业务专项账套名',
                type: 'input'
            },
            {
                prop: 'bsType',
                label: '业务专项',
                type: 'select',
                selectval: comMapping.$ywzx
            },
            {
                prop: 'defaulted',
                label: '是否默认',
                type: 'select',
                selectval: comMapping.$flag
            },
            {
                prop: 'nsrmc',
                label: '应用公司',
                type: 'input'
            },
            {
                prop: 'sobExplain',
                label: '说明',
                type: 'input'
            }
        ],
        searchdata: {
            sobName: '',
            bsType: '',
            defaulted: '',
            nsrmc: '',
            sobExplain: ''
        },
        headData: [
            {
                title: '业务专项账套名称',
                prop: 'sobName',
                width: 110,
                custom: true

            },
            {
                title: '业务专项',
                prop: 'bsType',
                width: 130,
                custom: true

            },
            {
                title: '是否默认',
                prop: 'defaulted',
                width: 50,
                custom: true

            },
            {
                title: '应用公司',
                prop: 'nsrmc',
                width: 130,
                custom: true

            },
            {
                title: '说明',
                prop: 'sobExplain',
                width: 160,
                custom: true

            },
            {
                title: '操作',
                prop: 'cz',
                custom: true,
                fixed: 'right',
                width: 250
            }
        ],
        pagination: {
            pageNum: 1,
            pageSize: 50,
            total: 0,
            paginationkey: 0
        }
    };
    return obj;
}
